import React, { useState } from "react";
import {
    Button,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    DialogContentText
} from "@mui/material";

interface BtnFooterProps {
    activeStep: number;
    totalSteps: number;
    onNext: () => void;
    onBack: () => void;
    onSubmit: () => void;
    onCancelExit: () => void;
    isFormValid: boolean;
    corfqId;
}

const BtnFooter: React.FC<BtnFooterProps> = ({
    activeStep,
    totalSteps,
    onNext,
    onBack,
    onSubmit,
    onCancelExit,
    isFormValid,
    corfqId
}) => {
    const [openExit, setOpenExit] = useState(false);

    /* ================= HANDLERS ================= */
    const handleCancel = () => setOpenExit(true);
    const closeDialog = () => setOpenExit(false);

    const confirmExit = () => {
        setOpenExit(false);
        onCancelExit(); // parent decides navigation
    };

    /* ================= RENDER ================= */
    return (
        <>
            {/* ================= FOOTER BUTTONS ================= */}
            <Grid container justifyContent="flex-end" spacing={2} mt={4}>
                {/* CANCEL – only on step 0 */}
                {activeStep === 0 && (
                    <Grid item>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </Grid>
                )}

                {/* BACK – hidden on step 0 */}
                {activeStep > 0 && (
                    <Grid item>
                        <Button variant="outlined" onClick={onBack}>
                            Back
                        </Button>
                    </Grid>
                )}

                {/* NEXT or SUBMIT */}
                <Grid item>
                    {activeStep === totalSteps - 1 ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={onSubmit}
                        >
                            Submit
                        </Button>
                    ) : (
                        <Button variant="contained" onClick={onNext}>
                            Next
                        </Button>
                    )}
                </Grid>
            </Grid>

            {/* ================= EXIT CONFIRMATION DIALOG ================= */}
            <Dialog open={openExit} onClose={closeDialog}>
                <DialogTitle>Exit Without Saving?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to exit the Customer Purchase
                        Order form?
                        <br />
                        Leaving this page will result in loss of all entered
                        data.
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeDialog} color="error">
                        Cancel
                    </Button>

                    <Button onClick={confirmExit} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default BtnFooter;
